/**
 * @class HamburgerMenu
 * use jquery
 */
export default class HamburgerMenu {
  /**
   * constructor
   */
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.$header = $(".l-header");
    this.$opjlogo = $('.opj-parts__top--nav h1');
    this.$menu = $('.opj-parts__menu');
    this.$menuButton = $('.opj-parts__menu--button');
    this.$menuCloseButton = $('.opj-parts__menu--closebutton');

    this.setup();
  }

  /**
   * setup
   */
  setup() {
    let self = this;

    // opj ハンバーガーメニュー開閉
    self.$menuButton.on('click', function(event){
      event.preventDefault();
      self.$body.addClass('is-noscroll');
      self.$menu.addClass('opj-is__open');
    });
    self.$menuCloseButton.on('click', function(event){
      event.preventDefault();
      self.$body.removeClass('is-noscroll');
      self.$menu.removeClass('opj-is__open');
    });
    // ハンバーガーメニュー レスポンシブ対応
    self.$window.on('resize', function(event) {
      event.preventDefault();
      if (window.matchMedia('(max-width:767px)').matches) {
        // sp
      } else {
        // pc
        self.$body.removeClass('is-noscroll');
        self.$menu.removeClass('opj-is__open');
      }
    });
    // ハンバーガーメニュー アンカーリンク
    self.$menu.find('a').on('click', function(event){
      let hash = $(this).data('hash');
      let href = $(this).attr('href');
      let pathname = location.pathname;
      if(hash) {
        event.preventDefault();
        if(pathname == '/special/onigiri-pj/' || pathname == '/special/onigiri-pj/campaign/' ) {
          // spの場合
          if(self.$body.hasClass('is-noscroll')) {
            self.$body.removeClass('is-noscroll');
            self.$menu.removeClass('opj-is__open');
          }
          // topの場合
          let position = $('#' + hash).offset().top;
          $('html, body').animate({ scrollTop : position }, 800);
        } else {
          // top以外
          location.href = href + '#' + hash;
        }
      }
    });

    this.scrollAction();
  }

  /**
   * scrollAction
   * おにぎりハンバガーメニューの表示非表示
   */
  scrollAction() {
    let self = this;
    let scl_top = 0;
    let startPos = 0;
    let winScrollTop = 0;
    let scrl_anim = !0;

    window.addEventListener("scroll", function (e) {
      if (window.matchMedia('(max-width:767px)').matches) {
        // sp
        // おにぎりロゴ色
        ($(this).scrollTop() > 28)
          ? self.$opjlogo.addClass('opj-is__scroll')
          : self.$opjlogo.removeClass('opj-is__scroll')

        // おにぎりハンバーガーメニューとロゴ
        self.$body.hasClass("is-active") || (
          winScrollTop = $(this).scrollTop(),
          self.$window.scrollTop() > scl_top
            ? self.$body.addClass("is-fixed")
            : self.$body.removeClass("is-fixed"),
          !0 === scrl_anim && (
            winScrollTop < startPos || winScrollTop <= scl_top
              ? (
                  scrl_anim =! 1,
                  self.$header.fadeIn(200, function () { scrl_anim = !0 }),
                  (self.$menuButton.find('button').fadeIn(200), self.$opjlogo.fadeIn(200))
                )
              : (
                  scrl_anim =! 1,
                  self.$header.fadeOut(200, function () { scrl_anim = !0 }),
                  (self.$menuButton.find('button').fadeOut(200), self.$opjlogo.fadeOut(200))
                )
          ),
          startPos = winScrollTop
        )
      }
    });
  }
}